module.exports = __webpack_public_path__ + "img/placeholder6.b8fb24b7.jpg";